import type { IconProps } from '../types'
import type { ReactElement } from 'react'

const ThickIcon = ({ className, color, onClick }: IconProps): ReactElement => {
  return (
    <svg
      className={className}
      fill="none"
      height="15"
      onClick={onClick}
      role="icon"
      stroke={color}
      viewBox="0 0 25 15"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.86133 6.25977L9.73633 12.7598L22.8613 1.25977" strokeLinecap="round" strokeWidth="2.5" />
    </svg>
  )
}

export default ThickIcon
